export interface otsConfig {
  flowConfigId?: string;
  promptId?: string;
  externalData?: string;
  jobId?: string;
  [key: string]: string | undefined;
}

export enum FlowConfigIdType {
  Etoro = 'etoro',
  Vanilla = 'vanilla',
  Custom = 'custom',
}
